import { MoneyFull } from './money-model';
export class CardOfferFull {

  limit: MoneyFull;

  constructor() {
    this.limit = new MoneyFull();
  }
}
